import { useCallback } from 'react';

interface Config {
  url: string;
  fileName: string;
}

export const useDownload = () => {
  const download = useCallback(({ url, fileName }: Config) => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }, []);

  return { download };
};
